import { Identifier } from "../graphql/baseTypes";
import ROUTES from "./routes";
export * from "./roles";
export { ROUTES };
export const IdentifierMapping: { [identifier in Identifier]: string } = {
  identity_card: "Ausweisnr.",
  insurance: "Versichertennr.",
  passport: "Reisepassnr.",
};

export const IdentifierLookup: { [key: string]: Identifier } = {
  "Ausweisnr.": "identity_card",
  "Versichertennr.": "insurance",
  "Reisepassnr.": "passport",
  "Ausweisnummer": "identity_card",
  "Versichertennummer": "insurance",
  "Reisepassnummer": "passport",
  "Versichtertenkarte": "insurance",

};
export const EMAI_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const DEFAULT_LIMIT = 20;
